import { render, staticRenderFns } from "./recordSubTable.vue?vue&type=template&id=ae1e2e8e&"
import script from "./recordSubTable.vue?vue&type=script&lang=ts&"
export * from "./recordSubTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports